export function isLessonPath(path: string, basePath = process.env.NEXT_CONFIG_BASE_PATH || '') {
    const normalizedPath = basePath && path.startsWith(basePath) ? path.slice(basePath.length) || '/' : path;
    return normalizedPath.startsWith('/lessons');
}
